import React from 'react';
import App from './containers/App';
import NotFound from './presentation/NotFound';
import { Switch, Route } from 'react-router-dom';

export default () => {
    return (
        <Switch>
            <Route path = "/" component={ App } />
            <Route path = "*" component = { NotFound } />
        </Switch>
    );
}



// WEBPACK FOOTER //
// ./src/routes.js